export const S = {
  APP_NAME: "Fintective",
  TAGLINE: "Financial Intelligence Dashboard",
  
  NAV_DASHBOARD: "Dashboard",
  NAV_FINDINGS: "Findings",
  NAV_TRANSACTIONS: "Transactions",
  NAV_PAYEES: "Payees",
  NAV_DETECTORS: "Detectors",
  NAV_FAMILY: "Family",
  NAV_SHARE: "Share & Earn",
  NAV_BILLING: "Billing",
  NAV_PROFILE: "Profile",
  NAV_ADMIN: "Admin",

  BADGE_INTELLIGENCE: "INTELLIGENCE FEED",
  BADGE_PAYEE_INTEL: "PAYEE INTELLIGENCE",
  BADGE_DETECTORS: "DETECTORS",
  BADGE_FAMILY: "FAMILY",
  BADGE_REFERRALS: "REFERRALS",
  BADGE_ACTIVE_SESSION: "Active Session",

  BTN_SYNC: "Sync Now",
  BTN_INVESTIGATE: "Investigate Now",
  BTN_RESOLVE: "Resolve",
  BTN_INVITE: "Invite",
  BTN_SAVE: "Save",
  BTN_LOGIN: "Sign In",
  BTN_LOGOUT: "Sign Out",
  SIDEBAR_HIDE_AMOUNTS: "Hide amounts",
  SIDEBAR_SHOW_AMOUNTS: "Show amounts",
  BTN_GOOGLE: "Continue with Google",
  BTN_UPGRADE: "Upgrade",
  BTN_MANAGE_BILLING: "Manage Billing",
  BTN_CONNECT_YNAB: "Connect YNAB",
  BTN_SELECT_PLAN: "Select Budget",
  BTN_ACCEPT_INVITE: "Accept Invite",
  BTN_REPORT: "Report",
  BTN_COPY: "Copy Link",
  BTN_CONTACT_SUPPORT: "Contact Support",

  STAT_TOTAL_CLUES: "Total Findings",
  STAT_ACTIVE_CASES: "Active Cases",
  STAT_RESOLVED: "Resolved",
  STAT_TOTAL: "Total",
  STAT_FLAGGED: "Flagged",
  STAT_SAFE: "Safe",

  TIER_FREE: "FREE",
  TIER_PRO: "PRO",
  TIER_PREMIUM: "PREMIUM",

  STATUS_TRIAL: "Trial",
  STATUS_MONTHLY: "Monthly",
  STATUS_YEARLY: "Yearly",
  STATUS_EXPIRED: "Expired",
  STATUS_TRIAL_EXPIRED: "Trial Expired",

  ERROR_RATE_LIMIT: "Too many requests. Please wait a moment.",
  ERROR_UNAUTHORIZED: "Session expired. Please sign in again.",
  ERROR_FORBIDDEN: "You don't have permission to access this resource.",
  TOAST_YNAB_SYNC_STARTED: "Sync started",
  TOAST_YNAB_SYNC_FAILED: "Failed to start sync",
  TOAST_YNAB_SYNC_SENT: "Sync request sent",
  TOAST_YNAB_SYNC_COMPLETED: "Sync completed",
  TOAST_YNAB_SYNC_RUNNING: "Sync is taking a little longer; it'll finish in the background",
  TOAST_YNAB_SYNC_IN_PROGRESS: "Sync already in progress",
  TOAST_INVESTIGATE_SENT: "Investigation request sent",
  TOAST_INVESTIGATE_COMPLETED: "Investigation completed",
  TOAST_INVESTIGATE_FAILED: "Failed to start investigation",
  TOAST_BILLING_PORTAL_FAILED: "Failed to open billing portal",
  TOAST_BILLING_CHECKOUT_FAILED: "Failed to start checkout",
  TOAST_BILLING_CHECKOUT_SUCCESS: "Payment received — your subscription is active",
  TOAST_BILLING_CHECKOUT_CANCELLED: "Checkout was not completed",
  TOAST_BILLING_CONFIRMING: "Confirming your subscription…",
  TOAST_BILLING_CONFIRMING_SLOW: "Still confirming your subscription — this can take a moment.",

  BILLING_CURRENT_PLAN: "Current Plan",
  BILLING_PLAN_STATUS_TRIAL: "Trial active",
  BILLING_PLAN_STATUS_BETA: "Beta access active",
  BILLING_PLAN_STATUS_TRIAL_EXPIRED: "Trial expired. Upgrade to keep investigations running.",
  BILLING_PLAN_STATUS_EXPIRED: "Subscription expired. Upgrade to resume full access.",
  BILLING_SECURITY_FREE_BADGE: "FREE forever",
  BILLING_SECURITY_FREE_HEADING: "Essential security detectors stay FREE",
  BILLING_SECURITY_FREE_DESCRIPTION: "Even after your trial expires, these security-conscious detectors will remain free. We know users rely on these protections, and we plan to keep supporting them.",
  BILLING_SECURITY_FREE_DETECTOR_DOUBLE_DIP: "Double Dip",
  BILLING_SECURITY_FREE_DETECTOR_NEW_PAYEE: "New Payee",
  BILLING_SECURITY_FREE_DETECTOR_WATCHED_PAYEE: "Watched Payee",
  BILLING_SECURITY_FREE_DETECTOR_FLAGGED_PAYEE: "Flagged Payee",
  BILLING_SECURITY_FREE_DETECTOR_GLOBAL_FLAGGED_PAYEE: "Global Flagged Payee",
  BILLING_BETA_PRICING_BADGE: "Beta",
  BILLING_BETA_PRICING_TITLE: "Currently free during active development",
  BILLING_BETA_PRICING_DESCRIPTION: "The price below is the planned post-beta price. When Fintective leaves beta, we will notify you before billing begins and give you a 30-day trial.",
  BILLING_BETA_DISABLED_TITLE: "Fintective is free during beta",
  BILLING_BETA_DISABLED_MESSAGE: "Fintective is in active development - and that's your gain: it's completely free right now. When we move out of beta, you'll be notified and placed on a trial period, giving you enough time to choose a plan.",
  BILLING_BETA_DISABLED_ACTION: "Got it",
  BILLING_PLAN_STATUS_MONTHLY: "Monthly subscription active",
  BILLING_PLAN_STATUS_YEARLY: "Yearly subscription active",
  BILLING_PRO_TITLE: "Pro",
  BILLING_PRO_PRICE: "$2.99 / Month",
  BILLING_PREMIUM_TITLE: "Premium",
  BILLING_PREMIUM_PRICE: "$1.99 / Month",
  BILLING_PREMIUM_NOTE: "Billed Yearly",
  BILLING_FEATURES_TITLE_PRO: "Pro Features",
  BILLING_FEATURES_TITLE_PREMIUM: "Premium Features",
  BILLING_HISTORY_TITLE: "Billing History",
  BILLING_HISTORY_EMPTY: "No billing history yet.",
  BILLING_LAST_PAYMENT_TITLE: "Last Payment",
  BILLING_LAST_PAYMENT_EMPTY: "No successful payment yet.",
  BILLING_LAST_PAYMENT_DATE: "Date",
  BILLING_LAST_PAYMENT_AMOUNT: "Amount",
  BILLING_LAST_PAYMENT_STATUS: "Status",
  BILLING_SUPPORT_TEXT: "Need help with billing?",
  SUBSCRIPTION_REQUIRED_TITLE: "Subscription required",
  SUBSCRIPTION_REQUIRED_DESCRIPTION: "Your trial or subscription has ended. Renew your subscription to restore Fintective access.",
  UPGRADE_TO_VIEW_TITLE: "Upgrade to view",
  UPGRADE_TO_VIEW_DESCRIPTION: "This page stays locked after your trial expires. Upgrade to restore full access.",
  UPGRADE_TO_VIEW_ADMIN_DESCRIPTION: "Admin reporting is disabled on expired plans until billing is restored.",

  // ── Connections: two kinds of source (budgeting apps and direct bank sync) ──
  CONN_TAB_BUDGET: "Second pair of eyes",
  CONN_TAB_BUDGET_SUB: "Connect your budgeting app",
  CONN_TAB_FEED: "Lead detective",
  CONN_TAB_FEED_SUB: "Connect your bank accounts directly",
  CONN_CHOOSER_TITLE: "How do you track money today?",
  CONN_CHOOSER_BUDGET_BODY: "You use a budgeting app like YNAB or Lunch Money. Fintective reads it and watches for problems; your app keeps owning your categories and budget.",
  CONN_CHOOSER_FEED_BODY: "You don't use a budgeting app. Fintective reads your bank transactions directly and manages the categories for you.",
  CONN_CHOOSER_PICK: "Choose",
  CONN_SWITCH_NOTICE_BUDGET: "You're using {app}. To switch to direct bank sync, disconnect {app} first.",
  CONN_SWITCH_NOTICE_FEED: "You're using direct bank sync. To switch to a budgeting app, disconnect your bank connections first.",
  CONN_OWNER_ONLY: "Ask an agency owner to connect or change sources.",
  CONN_LIMIT: "{used} of {max} bank connections used",
  CONN_NONE_YET: "Nothing connected yet.",
  CONN_LM_SUBTITLE: "Access token · Read-only connection",
  CONN_LM_INTRO: "Connect your Lunch Money account with an access token to import categories, budgets and transactions. Fintective only reads your data and never stores your Lunch Money password.",
  CONN_LM_ACCESS: "Access",
  CONN_LM_BADGE_ALT: "Powered by Lunch Money",
  CONN_BTN_CONNECT_LUNCHMONEY: "Connect Lunch Money",
  CONN_BTN_CONNECT_SIMPLEFIN: "Connect via SimpleFIN",
  CONN_BTN_CONNECT_WEBHOOK: "Add webhook",
  CONN_BTN_CONNECT_MONEYMAN: "Add Moneyman",
  CONN_BTN_SYNC_NOW: "Sync now",
  CONN_BTN_RECONNECT: "Reconnect",
  CONN_BTN_MANAGE: "Manage",
  CONN_BTN_DISCONNECT: "Disconnect",
  CONN_BTN_DELETE_DATA: "Delete data",
  CONN_BTN_CLOSE: "Close",
  CONN_STATUS_PENDING: "Connecting",
  CONN_STATUS_ACTIVE: "Up to date",
  CONN_STATUS_NEEDS_REAUTH: "Needs reconnect",
  CONN_STATUS_ERROR: "Problem",
  CONN_STATUS_PAUSED: "Paused",
  CONN_STATUS_DISCONNECTED: "Disconnected",
  CONN_HISTORY_KEPT: "History kept",
  CONN_PAST_HEADING: "Past connections",
  CONN_LAST_SYNC: "Last sync",
  CONN_NEVER_SYNCED: "Not yet",
  CONN_ACCOUNTS_TITLE: "Accounts",
  CONN_ACCOUNTS_HELP: "Only included accounts are analysed. Leaving one out hides what it already imported.",
  CONN_ACCOUNTS_EMPTY: "No accounts yet. They appear after the first sync.",
  CONN_EXCLUDE_CURRENCY: "Different currency than your account",
  CONN_EXCLUDE_DUPLICATE: "Looks like an account that is already connected",
  CONN_EXCLUDE_USER: "Left out by you",
  CONN_EXCLUDE_TYPE: "Account type isn't supported",
  CONN_DISCONNECT_TITLE: "Disconnect {name}?",
  CONN_DISCONNECT_BODY: "Fintective stops syncing and forgets the saved access. Your imported history stays unless you delete it.",
  CONN_DISCONNECT_KEEP: "Disconnect, keep history",
  CONN_DISCONNECT_DELETE: "Disconnect and delete data",
  CONN_DELETE_TITLE: "Delete imported data?",
  CONN_DELETE_PHRASE_PROMPT: "Type this phrase to continue:",
  CONN_DELETE_PHRASE_COPY: "Copy confirmation text",
  CONN_TOAST_PHRASE_COPIED: "Confirmation text copied",
  CONN_TOAST_PHRASE_COPY_FAILED: "Could not copy. Type the text instead.",
  CONN_DELETE_PHRASE_LABEL: "Data deletion confirmation text",
  CONN_DELETE_BODY: "This permanently removes everything {name} imported. It can't be undone.",
  CONN_TOAST_SYNC_REQUESTED: "Sync requested",
  CONN_TOAST_DISCONNECTED: "Disconnected",
  CONN_TOAST_DATA_DELETED: "Imported data deleted",
  CONN_TOAST_CONNECTED: "Connected",
  CONN_TOAST_FIRST_SYNC_FAILED: "Connected, but the first sync failed. We'll retry automatically.",
  CONN_ERR_GENERIC: "Something went wrong. Please try again.",
  CONN_SIMPLEFIN_TITLE: "Connect SimpleFIN",
  CONN_SIMPLEFIN_HOW: "SimpleFIN Bridge is a bank-connection service you sign up for yourself (about $1.50 a month, paid to SimpleFIN). You connect your banks there, then paste the one-time setup token here. Fintective gets read-only access that you can cancel any time.",
  CONN_SIMPLEFIN_STEP1: "Open SimpleFIN Bridge, sign up and connect your banks.",
  CONN_SIMPLEFIN_STEP2: "Create a setup token and paste it below.",
  CONN_SIMPLEFIN_LINK: "Open SimpleFIN Bridge",
  CONN_SIMPLEFIN_TOKEN: "Setup token",
  CONN_SIMPLEFIN_RECONNECT_TITLE: "Reconnect SimpleFIN",
  CONN_SIMPLEFIN_RECONNECT_BODY: "Your SimpleFIN access stopped working. Create a new setup token in SimpleFIN Bridge and paste it here.",
  CONN_LUNCHMONEY_TITLE: "Connect Lunch Money",
  CONN_LUNCHMONEY_HOW: "Fintective reads your categories, accounts, transactions and budgets from Lunch Money. Your categories and budgets stay in Lunch Money. Create an access token in Lunch Money's developer settings and paste it below.",
  CONN_LUNCHMONEY_DOCS: "How do I get a token?",
  CONN_LUNCHMONEY_TOKEN: "Access token",
  CONN_LUNCHMONEY_RECONNECT_TITLE: "Reconnect Lunch Money",
  CONN_LUNCHMONEY_RECONNECT_BODY: "Lunch Money rejected the saved token. Create a new one and paste it here.",
  CONN_MONEYMAN_TITLE: "Add Moneyman",
  CONN_MONEYMAN_HOW: "Moneyman scrapes your Israeli banks and cards and can post the transactions to Fintective. Fintective gives you a private key and an address to put in Moneyman's WebPost storage; your key is shown only once.",
  CONN_MONEYMAN_KEY_TITLE: "Authorization token",
  CONN_MONEYMAN_URL: "URL",
  CONN_MONEYMAN_CONFIG: "Moneyman configuration",
  CONN_MONEYMAN_DOCS: "Full documentation",
  CONN_MONEYMAN_NOTE: "Accounts arrive as the account number Moneyman reports. Rename them in the connection's accounts (Manage).",
  CONN_ACCOUNT_RENAME: "Rename",
  CONN_ACCOUNT_RENAME_LABEL: "Account name",
  CONN_ACCOUNT_RENAME_SAVE: "Save",
  CONN_ACCOUNT_RENAME_HELP: "Leave it empty to go back to the name the source reports.",
  CONN_ACCOUNT_REPORTED_AS: "Reported as {name}",
  CONN_TOAST_ACCOUNT_RENAMED: "Account renamed",
  ADMIN_USER_MONEYMAN: "Moneyman source",
  ADMIN_USER_MONEYMAN_HELP: "Let this agency connect Moneyman. The Moneyman switch under Sources must be on as well.",
  ADMIN_USER_SOURCE_UPDATED: "Source access updated",
  CONN_WEBHOOK_TITLE: "Add a webhook",
  CONN_WEBHOOK_HOW: "Send transactions from your own script or automation. Fintective gives you a private key and an endpoint; your key is shown only once.",
  CONN_WEBHOOK_NAME: "Name",
  CONN_WEBHOOK_KEY_TITLE: "Your ingest key",
  CONN_WEBHOOK_KEY_WARNING: "Copy it now. For your safety it is shown only once; you can rotate it later.",
  CONN_WEBHOOK_ENDPOINT: "Endpoint",
  CONN_WEBHOOK_EXAMPLE: "Example request",
  TX_CONVERTED_TITLE: "Converted from {currency} at {rate}",
  CONN_WEBHOOK_FORMAT: "Data format",
  CONN_WEBHOOK_FORMAT_HINT: "Send a list of up to 500 transactions; each one names its account and currency. Amounts are text with up to 3 decimals; negative means money out. Other currencies are converted to yours at the daily rate. Sending the same account_id and external_id again updates that transaction.",
  CONN_WEBHOOK_CATEGORIES: "Categories you can send",
  CONN_WEBHOOK_CATEGORIES_HINT: "Send one of these names in \"category\" (capitals don't matter). Add \"category_group\" as well to create a category that doesn't exist yet (up to 25 new ones per request). Anything else is saved without a category so you can choose one later in Transactions.",
  CONN_WEBHOOK_LAST_USED: "Key last used {when} from {ip}",
  CONN_WEBHOOK_NEVER_USED: "This key has not been used yet",
  CONN_WEBHOOK_DOCS: "Full documentation",
  CONN_WEBHOOK_ROTATE: "Rotate key",
  CONN_WEBHOOK_ROTATE_HELP: "The old key stops working right away.",
  CONN_BTN_CREATE: "Create",
  CONN_BTN_CONNECT: "Connect",
  CONN_BTN_COPY: "Copy",
  CONN_BTN_CANCEL: "Cancel",
  CONN_COPIED: "Copied",
  CONN_COPY_FAILED: "Couldn't copy",
  CONN_WARNINGS_TITLE: "Notes from the first sync",
  CONN_ERR_TOKEN_CLAIMED: "This setup token was already used. If you didn't use it yourself, it may be compromised: disable it in SimpleFIN Bridge and create a new one.",
  CONN_YNAB_BLOCKED_FEEDS: "Disconnect your bank connections before connecting YNAB.",
  CONN_YNAB_BLOCKED_LM: "Disconnect Lunch Money before connecting YNAB.",
  CONN_LM_BLOCKED_FEEDS: "Disconnect your bank connections before connecting Lunch Money.",
  CONN_LM_BLOCKED_YNAB: "Disconnect YNAB before connecting Lunch Money.",
  CONN_LOADING: "Loading connections…",
  CONN_FEED_ADD_BLOCKED_LIMIT: "You can have one bank connection at a time. Disconnect it to connect another.",
  CONN_PLAID_LOCK: "One-click bank connect is available on paid plans.",
  CONN_RECONNECT_BANNER: "{name} needs to be reconnected.",
  CONN_RECONNECT_BANNER_CTA: "Fix it",
  CONN_SOURCE_YNAB: "YNAB",
  CONN_SOURCE_LUNCHMONEY: "Lunch Money",
  CONN_SOURCE_SIMPLEFIN: "SimpleFIN",
  CONN_SOURCE_WEBHOOK: "Webhook",
  CONN_SOURCE_MONEYMAN: "Moneyman",
  CONN_SOURCE_PLAID: "Bank connect",

  // ── Categories and transaction edits (direct bank sync) ──
  CAT_MANAGED_EXTERNALLY: "Categories are managed in {app}.",
  CAT_MANAGE_TITLE: "Manage categories",
  CAT_MANAGE_HELP: "Rename, move, archive or delete categories. Archived categories are hidden from pickers but keep their history.",
  CAT_ADD: "Add category",
  CAT_NAME: "Name",
  CAT_GROUP: "Group",
  CAT_ARCHIVED: "archived",
  CAT_SHOW_ARCHIVED: "Show archived",
  CAT_ARCHIVE: "Archive",
  CAT_UNARCHIVE: "Unarchive",
  CAT_RENAME: "Rename",
  CAT_DELETE: "Delete",
  CAT_DELETE_TITLE: "Delete {name}?",
  CAT_DELETE_BODY: "{count} transactions use it. Choose where they should go.",
  CAT_DELETE_TO_UNCATEGORIZED: "Leave them uncategorized",
  CAT_DELETE_SYSTEM_HINT: "Default categories can be archived but not deleted.",
  CAT_TOAST_SAVED: "Category saved",
  CAT_TOAST_DELETED: "Category deleted",
  TX_UNCATEGORIZED: "Uncategorized",
  TX_NEEDS_CATEGORY: "Needs category ({count})",
  TX_PICK_CATEGORY: "Choose a category",
  TX_CLEAR_CATEGORY: "No category",
  TX_SET_CATEGORY: "Set category",
  TX_SELECTED: "{count} selected",
  TX_DELETE: "Delete",
  TX_HIDE: "Hide from Fintective",
  TX_RESTORE: "Restore",
  TX_VIEW_DELETED: "Deleted",
  TX_VIEW_ACTIVE: "Active",
  TX_DELETED_EMPTY: "Nothing deleted.",
  TX_TOAST_UPDATED: "Updated",
  TX_TOAST_DELETED: "Deleted",
  TX_TOAST_HIDDEN: "Hidden from Fintective",
  TX_TOAST_RESTORED: "Restored",
  DETECTOR_REQUIRES_BUDGET_APP: "Needs a budgeting app",
  DETECTOR_REQUIRES_BUDGET_APP_HINT: "This detector compares spending to your budget. Direct bank sync has no budget, so it stays off until you connect a budgeting app.",
  ADMIN_SOURCES_TITLE: "Source availability",
  ADMIN_SOURCES_DESC: "Turn a source on to let agencies connect it. Sources already connected keep syncing when a switch is turned off.",
  ADMIN_SOURCES_UPDATED: "Source availability updated",
  ADMIN_SOURCES_UPDATE_FAILED: "Failed to update availability",
  ADMIN_SOURCES_OFF: "Off",
  ADMIN_SOURCES_ON: "On",
  CARD_NEEDS_CATEGORY: "{count} transactions need a category",
  CARD_NEEDS_CATEGORY_CTA: "Categorize",

  EMPTY_FINDINGS: "No findings found. Run an investigation to detect anomalies.",
  EMPTY_TRANSACTIONS: "No transactions yet. Connect a budgeting app or your bank to import data.",
  ERROR_LOAD_GENERIC: "We couldn't load this right now. Please try again.",
  ERROR_RETRY: "Try again",
  EMPTY_PAYEES: "No payees found.",
  EMPTY_MEMBERS: "No members yet. Invite someone to get started.",
  NEED_CATEGORY: "Need Category",
  CATEGORIES_PERIOD_HINT: "Calculated over the past 12 months",

  // Fintective Score breakdown — each component is weighted (see per-component
  // max) and carries guidance on how to raise it.
  SCORE_BREAKDOWN_TITLE: "How to improve your score",
  SCORE_BREAKDOWN_SUBTITLE: "Each part is weighted differently. Here's what's holding you back and how to fix it.",
  SCORE_MAXED: "Maxed out — full points.",
  SCORE_DETECTORS_FIX: "Enable more detectors so Fintective investigates more of your spending.",
  SCORE_DETECTORS_CTA: "Manage detectors",
  SCORE_NOTIFICATIONS_FIX: "Turn on notifications for more detectors so you hear about new findings.",
  SCORE_NOTIFICATIONS_CTA: "Manage notifications",
  SCORE_YNAB_FIX: "Sync your connected source so your latest transactions are recent — within 3 days earns full points.",
  SCORE_FRESHNESS_LABEL: "Data freshness",
  SCORE_YNAB_CTA: "Manage connection",
  SCORE_STALE_FIX: "Review and resolve findings — clues left unresolved for more than a week pull your score down.",
  SCORE_STALE_FIX_COUNT: "You have {count} unresolved finding{s} older than a week. Resolve them to recover points.",
  SCORE_STALE_CTA: "Review findings",
  SCORE_DEVIATION_NO_ALLOCATION: "Set a category allocation first. Until you do, deviation stays at 0 — once set, we calculate how closely your spending matches your plan.",
  SCORE_DEVIATION_FIX: "Bring your actual category spending closer to your target allocation, or refine the targets.",
  SCORE_DEVIATION_CTA_SET: "Set allocation",
  SCORE_DEVIATION_CTA_REVIEW: "Review allocation",

  DASHBOARD_LOADING_TITLE: "Preparing your dashboard",
  DASHBOARD_LOADING_SUBTITLE: "We are loading your latest financial data.",
  DASHBOARD_ERROR_TITLE: "Dashboard unavailable",
  DASHBOARD_ERROR_SUBTITLE: "We could not load your latest financial data right now.",
  DASHBOARD_RETRY: "Try again",

  ONBOARDING_TITLE: "Connect where your money lives",
  ONBOARDING_DESCRIPTION: "Fintective inspects your transactions, finds unusual activity and builds your financial intelligence dashboard. Choose how it should get your transactions.",
  ONBOARDING_BUDGET_CTA: "Connect my budgeting app",
  ONBOARDING_FEED_CTA: "Connect my bank",
  ONBOARDING_PRIMARY: "Connect a source",
  ONBOARDING_SECONDARY: "I'll do this later",
  ONBOARDING_WHERE_TITLE: "Where things live",
  ONBOARDING_TRANSACTIONS_TITLE: "Transactions",
  ONBOARDING_TRANSACTIONS_LOCATION: "Left sidebar, Budget section",
  ONBOARDING_TRANSACTIONS_DESCRIPTION: "A full list of your imported transactions.",
  ONBOARDING_FINDINGS_TITLE: "Findings",
  ONBOARDING_FINDINGS_LOCATION: "Left sidebar, Investigation section",
  ONBOARDING_FINDINGS_DESCRIPTION: "All clues Fintective detects, including unusual charges, new merchants, spending spikes, and other alerts.",
  ONBOARDING_MONEY_FLOW_TITLE: "Money Flow",
  ONBOARDING_MONEY_FLOW_LOCATION: "Left sidebar, Budget section",
  ONBOARDING_MONEY_FLOW_DESCRIPTION: "A monthly view of income, outflows, and spending movement.",
  ONBOARDING_MONTHLY_PAYMENTS_TITLE: "Monthly Payments",
  ONBOARDING_MONTHLY_PAYMENTS_LOCATION: "Left sidebar, Budget section",
  ONBOARDING_MONTHLY_PAYMENTS_DESCRIPTION: "Recurring bills and subscription-like payments Fintective identifies.",
  ONBOARDING_DETECTORS_TITLE: "Detectors",
  ONBOARDING_DETECTORS_LOCATION: "Settings page, Detectors tab",
  ONBOARDING_DETECTORS_DESCRIPTION: "Controls for which checks Fintective runs and which ones can notify you.",
  ONBOARDING_NOTIFICATIONS_TITLE: "Notifications",
  ONBOARDING_NOTIFICATIONS_LOCATION: "Settings page, Notifications tab",
  ONBOARDING_NOTIFICATIONS_DESCRIPTION: "Email alert preferences.",
  ONBOARDING_FORMATTING_TITLE: "Formatting",
  ONBOARDING_FORMATTING_LOCATION: "Settings page, Formatting tab",
  ONBOARDING_FORMATTING_DESCRIPTION: "Currency, number, and date display settings.",
  ONBOARDING_HELP_TITLE: "Help",
  ONBOARDING_HELP_LOCATION: "Left sidebar, Settings & Account section",
  ONBOARDING_HELP_DESCRIPTION: "A guide to how Fintective works and what each area is for.",
  ONBOARDING_SUPPORT_TITLE: "Support",
  ONBOARDING_SUPPORT_LOCATION: "Left sidebar, Settings & Account section",
  ONBOARDING_SUPPORT_DESCRIPTION: "Reach support with questions or issues.",
  ONBOARDING_HELP_NOTE_TITLE: "Need help?",
  ONBOARDING_HELP_NOTE_DESCRIPTION: "The Help page explains how Fintective works and what each area is for. If you have a question or run into an issue, you can reach us from the Support page.",
  ONBOARDING_REPEAT: "Show onboarding again",
  ONBOARDING_REPEAT_DESCRIPTION: "Replay the quick guide to connecting a source and the dashboard areas.",

  LOGIN_TITLE: "Welcome to Fintective",
  LOGIN_SUBTITLE: "Sign in to access your financial intelligence dashboard",
  ERROR_INVALID_CREDENTIALS: "Username or password is incorrect.",
  ERROR_FORGOT_PASSWORD_GENERIC: "Something went wrong. Please try again.",
  AUTH_ACTION_LOADING_TITLE: "Checking your secure link",
  AUTH_ACTION_LOADING_DESCRIPTION: "Please wait while Fintective validates this request.",
  AUTH_ACTION_UNKNOWN_TITLE: "Unsupported link",
  AUTH_ACTION_UNKNOWN_DESCRIPTION: "This Firebase action link is not supported by Fintective.",
  AUTH_ACTION_EXPIRED_TITLE: "Invalid or expired link",
  AUTH_ACTION_RESET_EXPIRED_DESCRIPTION: "This password reset link is invalid or has expired.",
  AUTH_ACTION_VERIFY_EXPIRED_DESCRIPTION: "This verification link is invalid or has expired.",
  AUTH_ACTION_REQUEST_NEW_LINK: "Request a new link",
  AUTH_ACTION_BACK_TO_SIGN_IN: "Back to Sign In",
  AUTH_ACTION_PASSWORD_TITLE: "Set new password",
  AUTH_ACTION_PASSWORD_DESCRIPTION: "Enter your new password for this Fintective account.",
  AUTH_ACTION_PASSWORD_UPDATED_TITLE: "Password updated",
  AUTH_ACTION_PASSWORD_UPDATED_DESCRIPTION: "Your password has been reset successfully. You can now sign in.",
  AUTH_ACTION_VERIFY_TITLE: "Verifying your email",
  AUTH_ACTION_VERIFY_SUCCESS_TITLE: "Email verified",
  AUTH_ACTION_VERIFY_SUCCESS_DESCRIPTION: "Your Fintective account email has been verified. You can now sign in.",
  AUTH_ACTION_PASSWORD_MIN: "Password must be at least 8 characters",
  AUTH_ACTION_PASSWORD_MISMATCH: "Passwords do not match",
  AUTH_ACTION_PASSWORD_FAILED: "Failed to reset password. Please request a new link.",
  INVITE_PREVIEW_GENERIC: "Your request has been received. If the invite code is valid, you will be added to the agency.",

  CONSENT_TITLE: "Before you continue",
  CONSENT_SUBTITLE: "We need your confirmation to create your account.",
  CONSENT_CHECKBOX: "I confirm I am at least 18 years old and I agree to the Terms of Service and Privacy Policy.",
  CONSENT_CONFIRM: "Continue",
  CONSENT_DECLINE: "Cancel",
  CONSENT_DECLINE_EXISTING: "Sign out",
} as const;
